export const metrics = {
  pageContentPadding: { padding: "0 32px 24px" },
  elementSpacing: {
    medium: "8px",
    large: "20px",
  },
}
